import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon'
import { IconProps } from './types'

/**
 * [npm](https://github.com/Templarian/MaterialDesign-SVG/blob/master/svg/npm.svg) icon from [Material Design](https://github.com/Templarian/MaterialDesign)
 *
 * @author Contributors
 * @version 1.8.36
 */
export default function NpmIcon(props: IconProps) {
  return <Icon component={SVG} {...props} />
}

const SVG = () => <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24">
  <path d="M4,10V14H6V11H7V14H8V10H4M9,10V15H11V14H13V10H9M12,11V13H11V11H12M14,10V14H16V11H17V14H18V11H19V14H20V10H14M3,9H21V15H12V16H8V15H3V9Z" />
</svg>
